import Modal from 'react-bootstrap/Modal';
import "./broadcastDetails.css"
import PropTypes from "prop-types";
import React from 'react';

export default function BroadcastImageModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered 
    >
    <div className='preview-image-broadcast'>
        <img src={props.image} alt="preview-image" />
    </div>
    </Modal>
  );
}

BroadcastImageModal.propTypes = {
  image: PropTypes.string.isRequired 
};
